var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1474,
    height: 963,
    viewBox: "0 0 1474 963",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1488 -13H-24V985H1488V-13Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562 350.377C562.067 340.815 569.797 333.076 579.36 333H894.64C904.23 333 912 340.787 912 350.377V630.623C911.933 640.185 904.203 647.924 894.64 648H579.36C569.77 647.991 562 640.213 562 630.623V350.377ZM877.002 368.001H597.002V613.001L759.612 450.355C766.446 443.524 777.523 443.524 784.357 450.355L877.002 543.175V368.001ZM631.998 437.999C631.998 457.329 647.668 472.999 666.998 472.999C686.328 472.999 701.998 457.329 701.998 437.999C701.998 418.669 686.328 402.999 666.998 402.999C647.668 402.999 631.998 418.669 631.998 437.999Z",
    fill: "#687787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1474,
    height: 963,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.7dbd1f40f083044d41dcea389ce40866.svg";
export { ForwardRef as ReactComponent };